export default "__VITE_ASSET__oix1OZPm__"